/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import imagen_puntos_categoria from "../../../Recursos/imagen_puntos_categoria.png"
import {theme} from "../../../Tema";
import Tarjeta_Puntos from "../../Tarjetas/Tarjeta_Puntos";
import {useState} from "react";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Puntos_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container
                  size={{xs: 12, sm: 12, md: 12}}
                  sx={{maxWidth: "1400px", marginX: sCell ? 0 : 2}}>

                <Grid container
                      justifyContent={'center'}
                      alignItems={'center'}
                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontWeight: 800, fontSize: 32, color: theme.palette.primary.main}}
                    >
                        Puntos Fisicos
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={2}
                    >


                        {puntos.map((punto, index) => (
                            <Grid
                                size={{xs: 12, sm: 6, md: 6}}
                            >
                                <Tarjeta_Puntos
                                    item={punto}
                                />
                            </Grid>
                        ))}

                    </Grid>

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Puntos_Home

const puntos = [
    {
        imagen: imagen_puntos_categoria,
        nombre: 'Avenida Boyaca',
        direccion: 'Cll 12 N. 16-31',
        numero: '300 2008405',
        onClick: "Alert Punto 1",
        lat: 1.2042033,
        long: -77.28058
    },

];